module.exports = __webpack_public_path__ + "media/images/pages/linkedin_white-0b2fc966995227e9a269aa793507e0e8.png";